import type { Action } from "@reduxjs/toolkit";
import { isEqual } from "lodash";

export const valueChangedPredicate = <TState>(selector: (state: TState) => unknown) =>
	(action: Action, currentState: TState, previousState: TState) => {
		const oldValue = selector(previousState);
		const newValue = selector(currentState);

		return oldValue !== newValue;
	};

export const valueDeepChangedPredicate = <TState>(selector: (state: TState) => unknown) =>
	(action: Action, currentState: TState, previousState: TState) => {
		const oldValue = selector(previousState);
		const newValue = selector(currentState);

		return !isEqual(oldValue, newValue);
	};
